/**
 * Business Categories and Subcategories
 */

export const MAIN_CATEGORIES = [
  'Restaurants & Food',
  'Retail Stores',
  'Automotive',
  'Home Services',
  'Health, Beauty & Wellness',
  'Trades & Construction',
  'Transportation & Logistics',
  'E-Commerce & Online Businesses',
  'Professional Services',
  'Manufacturing & Industrial',
  'Daycare & Education'
];

export const SUB_CATEGORIES: Record<string, string[]> = {
  'Restaurants & Food': [
    'Restaurants for sale',
    'Pizza / Shawarma / Sushi / Indian',
    'Cafes / Bubble tea',
    'Bars / Pubs',
    'Catering / Food trucks',
    'Other Restaurants & Food'
  ],
  'Retail Stores': [
    'Convenience stores',
    'Vape / smoke shops',
    'Clothing / boutique',
    'Dollar / discount stores',
    'Specialty retail',
    'Other Retail Stores'
  ],
  'Automotive': [
    'Auto repair / mechanic',
    'Tire shop',
    'Car wash',
    'Auto detailing',
    'Body shop / collision',
    'Other Automotive'
  ],
  'Home Services': [
    'Cleaning companies',
    'Landscaping / lawn care',
    'HVAC',
    'Plumbing',
    'Electrical',
    'Roofing',
    'Painting',
    'Pest control',
    'Other Home Services'
  ],
  'Health, Beauty & Wellness': [
    'Hair salon / barbershop',
    'Spa / aesthetics',
    'Nail salon',
    'Massage / physio / chiro clinics',
    'Gym / fitness studio',
    'Other Health, Beauty & Wellness'
  ],
  'Trades & Construction': [
    'General contracting',
    'Renovation companies',
    'Concrete / paving',
    'Windows & doors',
    'Cabinets / millwork',
    'Other Trades & Construction'
  ],
  'Transportation & Logistics': [
    'Trucking companies',
    'Courier / delivery routes',
    'Moving companies',
    'Freight / logistics',
    'Other Transportation & Logistics'
  ],
  'E-Commerce & Online Businesses': [
    'Shopify stores',
    'Amazon FBA',
    'Digital products',
    'Subscription businesses',
    'Other E-Commerce & Online Businesses'
  ],
  'Professional Services': [
    'Accounting / bookkeeping firms',
    'Marketing agencies',
    'IT / managed services',
    'Staffing / recruitment',
    'Other Professional Services'
  ],
  'Manufacturing & Industrial': [
    'Fabrication / welding shops',
    'Packaging companies',
    'Small manufacturing plants',
    'Printing businesses',
    'Other Manufacturing & Industrial'
  ],
  'Daycare & Education': [
    'Daycares',
    'Tutoring centers',
    'Private schools / training centers',
    'Other Daycare & Education'
  ]
};

export const BUYER_TYPES = [
  'Owner-Operator',
  'Absentee / Semi-Absentee',
  'Turnkey',
  'High Cash Flow',
  'Low Investment',
  'Established (10+ years)',
  'Growing',
  'Includes Real Estate',
  'Leasehold',
  'Relocatable',
  'Home-Based'
];
